export async function authFetch(path, { headers = {}, ...options } = {}) {
  const runtimeConfig = useRuntimeConfig()
  const backendHost = runtimeConfig.public.BACKEND_HOST
  const domain = runtimeConfig.public.DOMAIN
  const cookie = useCookie('ressources_user_token', {
    maxAge: 3600,
    domain,
  })
  try {
    const result = await $fetch(`${backendHost}/${path}`, {
      headers: {
        ...headers,
        Authorization: cookie.value,
      },
      ...options,
    })
    if (result.errors) {
      console.log(result.errors)
      throw new Error('Graphql error(s) occured', result.errors)
    }
    return result
  } catch (error) {
    console.log(error)
    throw new Error('Error(s) occured', error)
  }
}
